export default __webpack_public_path__ + "static/cust_restaurant-f2b833d486559ac3d08be4e1a8814b58.webp";